<template>
  <router-view />
</template>

<script>

</script>

<style lang="less">
  @import "./assets/css/base.css";
</style>
